var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"verify-success text-center"},[_c('h1',[_vm._v(_vm._s(_vm.respon))]),_c('br'),_c('img',{attrs:{"src":require("../assets/img/verify-success.png"),"alt":"","width":"400"}}),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }